// Adding classes for tracking on elements of the page
jQuery(document).ready(function ($) {
	// Header Navigation tracking
	// Add classes to mega-menu-link inside the header -> ge-primary-nav.
	$('.main-header .menu-item a').addClass('ge-primary-nav');
	// Add classes to header "Get Started" button -> ge-primary-nav.
	$('.main-header__primary-cta').addClass('ge-primary-nav');
	// Add classes to header "Support" button -> ge-primary-nav.
	$('.main-header__secondary-cta').addClass('ge-primary-nav');

	// Footer Navigation tracking
	// Find the footer menu link, add a class of ge-footer-nav
	$('.main-footer .menu-item a').addClass('ge-footer-nav');

	// Breadcrumbs Navigation tracking
	// Find the breadcrumbs links, add a class of ge-click-breadcrumb
	$('.breadcrumbs a').addClass('ge-click-breadcrumb');

	// PDF tracking
	// If the link contains pdf, add a class of ge-click-downloadpdf
	// only add this class to pdfs if we are not currently on the card selector detail page, /solutions/fleet-cards/select/*/
	const thePageUrl = window.location.href;
	const theUrlChunk = 'solutions/fleet-cards/select';
	if (thePageUrl.indexOf(theUrlChunk) === -1) {
		$('a[href$="pdf"]').addClass('ge-click-downloadpdf');
	}

	// BOCA/Forms tracking
	// Add classes to BOCA links -> ge-click-boca.
	$(
		'a[href*="onlineservices.secure.force.com"], button[href*="onlineservices.secure.force.com"]'
	).each(function () {
		const thisTxt = $(this).text().toLowerCase();
		if (thisTxt !== null && thisTxt === 'apply now') {
			$(this).addClass('ge-click-boca');
		}
	});

	// External link (including regional + social sites) tracking
	// If the link hostname is not the same as this hostname, add a class of ge-click-external
	$('a')
		.filter(function () {
			return this.hostname && this.hostname !== location.hostname;
		})
		.addClass('ge-click-external');

	// Data Layer tracking
	// Google Tag Manager Form submission handler
	$(document).on('gform_confirmation_loaded', function (event, formID) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'formSubmission',
			// eslint-disable-next-line object-shorthand
			formID: formID,
		});
	});
});
